export var ManageAccountsSubjects;
(function (ManageAccountsSubjects) {
    ManageAccountsSubjects["SaveAccount"] = "save-changes";
    ManageAccountsSubjects["EnableFlexibility"] = "activate-flexibility";
    ManageAccountsSubjects["DisableFlexibility"] = "deactivate-flexibility";
    ManageAccountsSubjects["DeleteSubAccount"] = "delete";
    ManageAccountsSubjects["ManageAccountsPage"] = "manage-accounts-page";
    ManageAccountsSubjects["ManageConsumptionAccountPage"] = "manage-consumption-accounts-page";
    ManageAccountsSubjects["LogsProductCard"] = "logs-product-card";
    ManageAccountsSubjects["MetricsProductCard"] = "metrics-product-card";
    ManageAccountsSubjects["TracingProductCard"] = "tracing-product-card";
    ManageAccountsSubjects["SecurityProductCard"] = "security-product-card";
    ManageAccountsSubjects["TimelessProductCard"] = "timeless-product-card";
})(ManageAccountsSubjects || (ManageAccountsSubjects = {}));
export var ManageAccountsCardNames;
(function (ManageAccountsCardNames) {
    ManageAccountsCardNames["LogsList"] = "manage-accounts-accounts-card";
    ManageAccountsCardNames["LogsEdit"] = "manage-accounts-edit-account-section";
    ManageAccountsCardNames["SiemList"] = "manage-accounts-security-accounts-card";
    ManageAccountsCardNames["SiemEdit"] = "manage-accounts-edit-security-account-section";
    ManageAccountsCardNames["TimelessList"] = "manage-accounts-timeless-accounts-card";
    ManageAccountsCardNames["TracingList"] = "manage-accounts-tracing-accounts-card";
    ManageAccountsCardNames["MetricsList"] = "manage-accounts-metrics-accounts-card";
})(ManageAccountsCardNames || (ManageAccountsCardNames = {}));
export var SecurityRepositoryTestSubject;
(function (SecurityRepositoryTestSubject) {
    SecurityRepositoryTestSubject["CantDeleteDialog"] = "cannot-delete-repository-dialog";
    SecurityRepositoryTestSubject["ChangeRepositoryNotification"] = "change-repository-notification";
    SecurityRepositoryTestSubject["ResetLink"] = "reset-repository-account";
    SecurityRepositoryTestSubject["InfobarSubject"] = "siem-repo-infobar";
    SecurityRepositoryTestSubject["ModalSelectRepository"] = "list-repository-accounts";
    SecurityRepositoryTestSubject["ModalSubject"] = "manage-repository";
    SecurityRepositoryTestSubject["PopupNotificationSubject"] = "siem-repo-notification";
})(SecurityRepositoryTestSubject || (SecurityRepositoryTestSubject = {}));
//# sourceMappingURL=manage-accounts.enum.js.map